function useConfig() {
  const BASE_URLS = {
    LOCALHOST: "https://localhost.letscreate.zone:3010",
    LIVE: "https://server-warehouse-server-staging.letscreate.zone",
  };
  let API_URL = BASE_URLS.LIVE + "/api"; //Default to localhost
  const API_URLS = {
    "mybigcommerce.com": BASE_URLS.LIVE,
    "serverbuilds.co.uk": BASE_URLS.LIVE,
    "localhost:3002": BASE_URLS.LOCALHOST,
  };

  const browserURL = window.location.href;
  console.log("browserURL", browserURL);
  for (let partialURL in API_URLS) {
    if (browserURL.indexOf(partialURL) > -1) {
      API_URL = API_URLS[partialURL] + "/api";
      break;
    }
  }

  console.log("Using API", API_URL);

  return {
    bigCommerceStoreHash: "xzo998w3ks",
    API_URL,
  };
}
export default useConfig;
